var React = require('react');

function Balcon2 (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M23.6094 24.8154H2.38998C1.7234 24.8154 1.18481 24.2758 1.18481 23.6092V2.39079C1.18481 1.7242 1.7234 1.18463 2.38998 1.18463H23.6094C24.276 1.18463 24.8156 1.7242 24.8156 2.39079V23.6092C24.8156 24.2758 24.276 24.8154 23.6094 24.8154Z","stroke":"#212121","strokeWidth":"2","key":0}),React.createElement("path",{"d":"M1.18445 15.8308H24.8152","stroke":"#212121","strokeWidth":"2","strokeLinecap":"round","key":1}),React.createElement("path",{"d":"M9.0614 4.52307V15.3385","stroke":"#212121","strokeWidth":"2","strokeLinecap":"round","key":2}),React.createElement("path",{"d":"M16.446 1.18463V15.3385","stroke":"#212121","strokeWidth":"2","strokeLinecap":"round","key":3})]);
}

Balcon2.defaultProps = {"width":"26","height":"26","viewBox":"0 0 26 26","fill":"none"};

module.exports = Balcon2;

Balcon2.default = Balcon2;
